// extracted by mini-css-extract-plugin
module.exports = {"sectionContainer":"Section_sectionContainer___iJiy","section":"Section_section___ODhG"};